import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      margin: '0',
      padding: '10px',
      width: 'fill',
      color: palette.text.primary,
      borderRadius: palette.borderRadius.default,
      fontWeight: 600,
      background: palette.background.underBox,
      display: 'flex',
      flexDirection: 'column',
      gap: '5px'
    },
    red: {
      background: palette.common.red,
      color: palette.text.white
    },
    green: {
      background: palette.common.green,
      color: palette.text.darker
    },
    grey: {
      backgroundColor: palette.text.primary,
      color: palette.common.white
    },
    orange: {
      backgroundColor: palette.common.orange,
      color: palette.common.white
    },
    bold: {
      fontWeight: 700,
      fontSize: '1.25rem'
    },
    bottomBold: {
      fontWeight: 700,
      fontSize: '1.25rem',
      marginTop: '5px'
    },
    bottomQuiz: {
      fontSize: '1.25rem',
      marginTop: '5px',
      textAlign: 'center',
      '@media (min-width: 426px)': {
        fontSize: '1.5rem',
        textAlign: 'left'
      }
    },
    bottomRegular: {
      marginTop: '5px'
    },
    regularRed: {
      color: palette.common.red,
      fontSize: '0.8rem'
    },
    regularBlue: {
      color: palette.common.primaryBlue,
      fontSize: '0.8rem'
    },
    title: {
      fontWeight: 500
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
